import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import type { StateCreator } from 'zustand/vanilla';

import { ENV } from '@/constants/env';
import { Language } from '@/constants/languages';
import { createSelectors } from '@/libs/zustand';
import { StorageStoreDefault } from '@/models/store';

export const LOCALE_PERSIST_KEY = 'abonoComLocale';

export interface LocaleState {
    locale: Language;
}

interface LocaleActions {
    setLocale: (locale: Language) => void;
}

type StateAndActions = LocaleState & LocaleActions & StorageStoreDefault;

const store: StateCreator<StateAndActions> = (set) => ({
    locale: ENV.DEFAULT_APP_LOCALE as Language,
    isStorageLoaded: false,

    setLocale: (locale) => set((state) => (state.locale !== locale ? { locale } : state)),
    setIsStorageLoaded: () => set((state) => (!state.isStorageLoaded ? { isStorageLoaded: true } : state)),
});

const useLocaleStoreBase = create<StateAndActions>()(
    persist(immer<StateAndActions>(store), {
        name: LOCALE_PERSIST_KEY,
        partialize: ({ locale }) => ({ locale }),
        onRehydrateStorage: () => (state) => {
            state?.setIsStorageLoaded();
        },
    }),
);

export const useLocaleStore = createSelectors(useLocaleStoreBase);
